<div class="profile-badge-border" [style.border]="isSPPBot ? 'none' : '2px solid #EBE2C3'">
  <div class="profile-badge" [style.background-color]="isSPPBot ? '#F1EBD7' : '#FDFAF4'">
    <div [style.color]="textColor" class="badge-text" [class.bot-text]="isSPPBot">
      {{ isSPPBot ? 'SPP' : initials }}
    </div>
  </div>
</div>
